$(() => {
  const pricingTableSection = $('.pricing-table');
  const pricingTableHeader = pricingTableSection.find('.pricing-table-header');
  const pricingTableContent = pricingTableSection.find('.pricing-table-content');

  if (pricingTableSection.length === 0) {
    return;
  }

  let headerScrolling = false;
  let contentScrolling = false;
  
  pricingTableHeader.on('scroll', function() {
    if (!contentScrolling) {
      headerScrolling = true;
      pricingTableContent.scrollLeft($(this).scrollLeft());
      headerScrolling = false;
    }
  });

  pricingTableContent.on('scroll', function() {
    if (!headerScrolling) {
      contentScrolling = true;
      pricingTableHeader.scrollLeft($(this).scrollLeft());
      contentScrolling = false;
    }
  });
});
